import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import './OrganizationModal.css';
import { BaseModalV2, Input, Label, ErrorMessage, PrimaryButton, SecondaryButton } from '../common';
import { useFeedbackContext } from '../../context';
import { ACTION_TYPES, EMPTY_FIELD_ERROR } from '../../constants';
import { serviceLogger } from '../../utils/serviceLogger';

const OrganizationModal = ({ action, organization, onSave, onClose }) => {
  const { showToast } = useFeedbackContext();

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
    setValue,
  } = useForm({
    mode: 'onChange',
  });

  useEffect(() => {
    if (action === ACTION_TYPES.EDIT && organization) {
      setValue('name', organization.name || '');
      setValue('industry', organization.industry || '');
      setValue('email', organization.email || '');
    }
  }, [action, organization, setValue]);

  const onSubmit = async (data) => {
    try {
      await onSave(data);
    } catch (error) {
      serviceLogger.error('Failed to save organization:', error);
      showToast({
        variant: 'error',
        title: 'Save failed',
        copy: 'We could not save your changes. Please try again.',
      });
    }
  };

  return (
    <BaseModalV2
      title={action === ACTION_TYPES.ADD ? 'Add Organization' : 'Edit Organization'}
      onClose={onClose}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="form-group">
          <Label variant="gray">Organization Name</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="Organization Name"
            autoFocus
            {...register('name', { required: EMPTY_FIELD_ERROR })}
          />
          {errors.name && <ErrorMessage message={errors.name.message} className="!static mt-2" />}
        </div>

        <div className="form-group">
          <Label variant="gray">Industry</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="Industry"
            {...register('industry', { required: EMPTY_FIELD_ERROR })}
          />
          {errors.industry && (
            <ErrorMessage message={errors.industry.message} className="!static mt-2" />
          )}
        </div>

        <div className="form-group">
          <Label variant="gray">Email</Label>
          <Input
            variant="primary"
            customClass="!max-w-full"
            placeholder="Email"
            {...register('email', { required: EMPTY_FIELD_ERROR })}
          />
          {errors.email && <ErrorMessage message={errors.email.message} className="!static mt-2" />}
        </div>

        <div className="modal-buttons">
          <SecondaryButton onClick={onClose}>Cancel</SecondaryButton>
          <PrimaryButton onClick={() => {}} type="submit" disabled={!isValid}>
            Save
          </PrimaryButton>
        </div>
      </form>
    </BaseModalV2>
  );
};

export default OrganizationModal;
